import React, { useState, useEffect } from 'react';
import * as newsService from "../services/newsService";
import SunEditor, { buttonList } from 'suneditor-react';
import { Calendar } from 'primereact/calendar';
import { FormatDateBG } from '../../utils/RegisterApplicationBodyFormatter';
import 'suneditor/dist/css/suneditor.min.css'; // Import Sun Editor's CSS File
import Swal from 'sweetalert2'
export function AdminAddEditForeigners() {
    const [show, setShow] = useState(false);

    const [formData, setFormData] = useState({
        title: '',
        data: '',
        news: '',
    });

    const handleContentChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleContentChangeEditor = (e) => {
        setFormData({ ...formData, news: e });
    };

    const onClickHeandler = (val) => {

        if (formData.title === '') { Swal.fire({ title: "Внимание", text: 'Моля въведете заглавие на новината!', icon: "error" }); return; }
        if (formData.data === '') { Swal.fire({ title: "Внимание", text: 'Моля въведете дата за новината!', icon: "error" }); return; }
        if (formData.news === '') { Swal.fire({ title: "Внимание", text: 'Моля въведете съдържание на новината!', icon: "error" }); return; } 

        const body = {
            title: formData.title,
            news: formData.news,
            data: FormatDateBG(formData.data),
            category_id: 4,
            forHomePage: false,
        }

        const updateNews = async () => {
            try {
                setShow(false);
                newsService.update(formData.id_news, body)
                    .then((res) => {
                        Swal.fire({ title: "Успешно обновяване!", text: "", icon: "success" });
                        setShow(true);
                    })
            } catch (error) {
                Swal.fire({ title: "Грешка при обновяване!", text: error.message, icon: "error" });
            }
        }

        updateNews();
    }

    useEffect(() => {
        const populateHome = async () => {
            try {
                newsService.getForeignersInfo()
                    .then((res) => {
                        let r = res[0];
                        let data = r.data.split('-');
                        setFormData( prevState => ({
                            "id_news": r.id_news,
                            "title": r.title,
                            "data": new Date(data[2], data[1] - 1, data[0]),
                            "news": r.news,
                            "category_id": 4,
                            "forHomePage": false,

                        }))
                        setShow(true);
                    })
            } catch (error) { console.error('Error fetching data:', error.message); }
        };

        populateHome();

        document.title = `Указания чужденци`;
    }, []);

    return (
        <main id="main" className="main ">

            <div className="pagetitle">
                <h1>Указания за чужденци</h1>
                <nav>
                    <ol className="breadcrumb">
                        <li className="breadcrumb-item"><a href="/schadm">Начало</a></li>
                        <li className="breadcrumb-item active">Добавяне - Редакция </li>
                    </ol>
                </nav>
            </div>

            <section className="section dashboard " >

                <div className="row h-100">

                    <div className="col-lg-12">
                        <div className="row news_bg h-100">
                            <div className="h-100">
                            

                                {show &&
                                    <div className="h-100">
                                        <form>
                                            <div className="w-100">
                                                Заглавие:<br />
                                                <input type="text" id="title" name="title" value={formData.title} onChange={handleContentChange} className="w-100" />
                                            </div>
                                            {/*<div className="mb-3">*/}
                                            {/*    Дата:<br /><input type="text" id="data" name="data" value={formData.data} onChange={handleContentChange} />*/}
                                            {/*</div>*/}
                                            <div className="mb-3 mt-2">
                                                <Calendar
                                                    showButtonBar
                                                    locale='bg'
                                                    className="prime-dropdown-heigth"
                                                    name="data"
                                                    value={formData.data ? formData.data : null}
                                                    onChange={handleContentChange}
                                                    showIcon
                                                />
                                            </div>
                                            

                                            <SunEditor
                                                lang="en"
                                                autoFocus={true}
                                                name="html-editor"
                                                setOptions={{
                                                    height: '65vh',
                                                    buttonList: [
                                                        ['undo', 'redo'],
                                                        ['font', 'fontSize', 'formatBlock'],
                                                        ['paragraphStyle', 'blockquote'],
                                                        ['bold', 'underline', 'italic', 'strike', 'subscript', 'superscript'],
                                                        ['fontColor', 'hiliteColor', 'textStyle'],
                                                        ['removeFormat'],
                                                        ['outdent', 'indent'],
                                                        ['align', 'horizontalRule', 'list', 'lineHeight'],
                                                        ['table', 'link', 'image', /** 'video', 'audio'  ,'math' */], // You must add the 'katex' library at options to use the 'math' plugin.
                                                        /** ['imageGallery'] */ // You must add the "imageGalleryUrl".
                                                        ['showBlocks', 'codeView'],
                                                        ['preview', 'print'],
                                                    ]
                                                }} // Initialize with HTML content
                                                setContents={formData.news}
                                                onChange={handleContentChangeEditor} // Handle content change
                                            />
                                            <div className="text-center">
                                                <button type="button" className="btn btn-primary mt-3 mb-3" onClick={() => onClickHeandler()} >{formData.news!== '' ? 'Редакция' : 'Добави'}</button>
                                            </div>
                                        </form>
                                    </div>
                                    }
                                

                            </div>
                        </div>
                    </div>

                </div>

            </section>

        </main>
    )
}

export default AdminAddEditForeigners;

